import { logoutAsync } from "./EditUserProfile/EditUserProfile.service";
import { logout } from "./UserProfile.utils";

const init = {
  heading: "Confirmation",
  submitText: "Proceed",
  cancelText: "Cancel",
  contentText: "Unsaved changes will be lost. Do you want to proceed?",
  onSubmit: "",
  onCancel: "",
  size: "md",
};

export const handleLogout = () => {
  logoutAsync()
    ?.then((res) => {
      if (res.data.statusCode === 200) logout();
    })
    .catch((err) => {
      if ([400, 401].includes(err?.response?.status)) logout();
    });
};
export function autoLogout({ timer }) {
  if (timer == 0) handleLogout();
}

export const triggerPopOver = ({ showPopOver, setshowPopOver }) => {
  if (showPopOver === true) {
    setshowPopOver(false);
    return;
  }
  setshowPopOver(true);
};

export const checkingDataToShowPrompt = ({
  setConfirmDialogOptions,
  promptModalSubmit,
  closePromptDialog,
  setShowConfirmDialog,
}) => {
  if (sessionStorage.getItem("promptUser")) {
    setConfirmDialogOptions({
      ...init,
      contentText: sessionStorage.getItem("promptMessage") || init.contentText,
      onSubmit: () => promptModalSubmit(),
      onCancel: closePromptDialog,
    });
    setShowConfirmDialog(true);
  } else {
    promptModalSubmit();
  }
};

export const promptModalSubmit = ({ setShowConfirmDialog, handleLogout }) => {
  handleLogout();
  setShowConfirmDialog(false);
};

export const closePromptDialog = ({ setShowConfirmDialog }) => {
  setShowConfirmDialog(false);
};
